import React from "react";
import Footer from "../../Home/Footer";
import Header from "../../Home/Header";
import Productunique from "../Product/productunique";
import Productunique2 from "../Product/Productunique2";
const UniqueProducts = () => {
  return (
    <>
      <Header />
      <Productunique/>
      <Productunique2/>
      <Footer />
    </>
  );
};

export default UniqueProducts;
